
<div>
    <f-title
        v-if  = "isLim && showTitle"
        :title = "$t('contract.billing')"
        class = "mt-10"
    />

    <c-column-header
        v-if   = "isLim && !showTitle"
        class  = "primary mt-1"
        :label = "$t('contract.billing')"
    />

    <div :class="border"  v-if="isLim">
        <v-row class="no-frame"  >
            <v-col class="no-frame">
                <f-enum-select
                    v-model      = "contract.invoiceHandling"
                    :readonly    = "readonly"
                    label        = "Gruppierung"
                    module       = "msd"
                    type         = "limInvoiceHandling"
                    :rules    = "[ requiredRule ]"
                />
            </v-col>
        </v-row>

        <v-row class="no-frame">
            <v-col class="no-frame">
                <f-enum-select
                    v-model    = "contract.tier"
                    :readonly  = "readonly"
                    :label     = "$t('contract.lim.tier')"
                    module     = "msd"
                    type       = "contractLimTier"
                    :clearable = "true"
                />
            </v-col>
        </v-row>

        <v-row class="no-frame">
            <v-col class="no-frame pr-2">
                <v-text-field
                    type      = "number"
                    :label    = "$t('contract.lim.splitMaintenance')"
                    :readonly = "readonly"
                    v-model   = "contract.splitMaintenance"
                    :rules    = "percentRule"
                    @input    ="onChangeSplitMaintenance"
                />
            </v-col>
            <v-col class="no-frame p-2">
                <v-text-field
                    type      = "number"
                    :label    = "$t('contract.lim.splitRepair')"
                    :readonly = "readonly"
                    v-model   = "contract.splitRepair"
                    :rules    = "percentRule"
                    @input    = "onChangeSplitRepair"
                />
            </v-col>
        </v-row>
    </div>


    <f-title
        v-if   = "showTitle"
        class  = "mt-5"
        :title = "$t('contract.addresses')"
    />

    <c-column-header
        v-if   = "!showTitle"
        class  = "primary mt-2"
        :label = "$t('contract.addresses')"
    />

    <div
        :class="border"
    >
        <v-row class="no-frame mb-5">
            <s-contract-lim-recipients
                v-model   = "contract.benefitRecipient"
                :label    = "$t('contract.recipient.benefit')"
                :customer = "contract.customer.id"
                :readonly = "readonly"
                :rules    = "[ requiredRule ]"
                type      = "benefit"
            />
        </v-row>

        <v-row class="no-frame" >
            <s-contract-lim-recipients
                v-model   = "contract.invoiceRecipient"
                :label    = "$t('contract.recipient.invoice')"
                :customer = "contract.customer.id"
                :readonly = "readonly"
                :rules    = "[ requiredRule ]"
                type      = "invoice"
            />
        </v-row>
    </div>

</div>
